<template>
   <span>
    <!-- No <notifications> host here: this component renders once per user row,
         and every mounted default-group host renders its own copy of each toast.
         UserSearch.vue provides the single page-level host. -->

       <a @click="isOpen = !isOpen" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
          <i class="fas fa-bullhorn mr-3 w-5 text-pink-500 group-hover:text-pink-700"></i>
         Support Campaign
        </a>


    <transition v-if="isOpen"
                enter-class="transition ease-out duration-100 transform"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-in duration-200 transform"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >

      <div  class="fixed z-50 inset-0 overflow-y-auto  ">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 ">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all lg:my-8 lg:align-middle lg:max-w-2xl lg:w-1/2 lg:p-6">
          <div class="sm:flex sm:items-start">

            <div class="text-center sm:mt-0 sm:text-left w-full">

              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  User: <span class="font-bold"> {{user.name}} - {{user.email}} ({{user.id}})</span>
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 overflow-hidden">
                <p class=" px-2 mb-5">
                  <span class="font-bold text-red"> will be supporting: {{selectedCampaign}}</span>
                </p>
              </div>

              <div class="">
                 <p class="px-1">Search for campaign</p>
                <campaign-search-input :show-only-top-level-campaigns="false" />
              </div>

            </div>

          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button @click="supportCampaign" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm">
              Support Campaign
            </button>
            <button @click="isOpen = false" type="button" class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>


        </div>
      </div>
      </div>

    </transition>
   </span>
</template>

<script>
import { buildHttpErrorNotification } from '../../http-error-notifier'

export default {
  name: 'SupportACampaign',
  props: {
    user: null,
  },
  created() {

    // The search input broadcasts on the global emitter and AllowAnotherCampaign
    // shares it on the same row, so only take a selection while this modal is open.
    this.emitter.on('search-selected-campaign', selectedCampaignFromSearch => {
      if (this.isOpen) this.selectedCampaignFromSearch = selectedCampaignFromSearch;
    });

    this.emitter.on('search-selected-campaign-reset', selectedCampaignFromSearch => {
      this.selectedCampaignFromSearch = null;
    });
  },
  data() {
    return {
      isOpen: false,
      selectedCampaignFromSearch: null,
    }
  },
  computed: {
    selectedCampaign(){
      return this.selectedCampaignFromSearch ? this.selectedCampaignFromSearch.name+' ('+ this.selectedCampaignFromSearch.id+')': ''
    }
  },
  methods: {
    setOpenToFalse() {
      this.isOpen = false;
    },

    supportCampaign() {
      if (!this.selectedCampaignFromSearch) {
        this.$notify({
          text: 'Please select a campaign user wants to support.',
          type: 'error',
        })
        return
      }
      const data = new FormData();
      let token = document.head.querySelector('meta[name="csrf-token"]');
      data.append('_token',  token.content);
      data.append('campaign_id',  this.selectedCampaignFromSearch.id);
      data.append('user_id',  this.user.id);

      axios.post('/admin/support-a-campaign', data)
          .then(response => {
            this.$notify({text: 'User has been impersonated, now redirecting to support page... ',type: 'success', })

            setTimeout(() => {
              this.isOpen = false
              window.location.href = '/create-my-campaign/'+this.selectedCampaignFromSearch.id
            }, 2000)
          })
          .catch(error => {
            // Without this the modal just sits there on a 403/419/500 and the
            // admin has no way to tell a denied request from a dead button.
            this.$notify(buildHttpErrorNotification(error))
          })
    },
  },

  watch: {
    isOpen() {
      this.emitter.emit('search-selected-campaign')
    },
  },

}
</script>
